<template>
  <div class="mian-music">
    <div class="music-control">
      <!-- 进度条 -->
      <div ref="maxBar" class="progress-time">
        <div ref="bar" class="current-time" :style="{ width: currentP + '%' }" />
      </div>
      <div class="control-infor">
        <img
          v-if="musicUrl.length"
          :src="musicUrl[musicIndex].imgUrl"
          alt="封面"
        />
        <div v-if="musicUrl.length" class="music-infor">
          <p>{{ musicUrl[musicIndex].articleTitle }}</p>
          <p>{{ musicUrl[musicIndex].summary[0] }}</p>
        </div>
      </div>
      <div class="control-btn">
        <i class="last-music" @click="changeMusic('before')" />
        <i
          class="to-pause"
          :class="{ pause: !ispause }"
          @click="
            playMusic();
            appearPlay();
          "
        />
        <i
          class="to-play"
          :class="{ pause: ispause }"
          @click="
            playPause();
            appearPause();
          "
        />
        <i class="next-music" @click="changeMusic('next')" />
      </div>
      <div class="control-time">
        <span class="active-times">{{ currentTime }}</span>
        <span>/</span>
        <span class="all-times">{{ allTimes }}</span>
      </div>
    </div>
    <audio
      v-if="musicUrl.length"
      ref="audio"
      class="audio"
      :src="musicUrl[musicIndex].vid"
      @canplaythrough="getAllTime"
    />
  </div>
</template>

<script>
import { getMusicList } from '@api/ingame';
export default {
  data() {
    return {
      ispause: false,
      currentP: 0, // 进度条长度
      currentTime: '00:00', // 当前时间
      allTimes: '00:00', // 总时长
      now: '00:00', // 记录当前时间
      all: '00:00', // 记录总时长
      initialW: 0, // 保存进度条最初的长
      currentPSave: 0, // 保存进度条变化的长
      state: false, // 关闭定时器
      // musicUrl: [
      //   "//demo.17weiju.com/gp/mp3/mp3.mp3",
      //   "//demo.17weiju.com/gp/mp3/mp31.mp3",
      //   "//demo.17weiju.com/gp/mp3/mp32.mp3",
      // ],
      musicUrl: [], // mp3数据
    };
  },
  computed: {
    musicIndex() {
      return this.$store.state.music.musicIndex; // 需要监听的数据
    },
    play() {
      return this.$store.state.music.currentMusic.play; // 需要监听的数据
    },
    musicUrl1() {
      return this.$store.state.music.musicUrl; // 需要监听的数据
    },
  },
  watch: {
    play(val) {
      this.toPlay(val);
    },
    ispause(val) {
      this.$store.commit('IS_PAUSE_MODIFY', val);
    },
    musicIndex(val) {
      this.$store.commit('MUSIC_INDEX', val);
      this.$store.commit('IS_SHOW_MODIFY', val);
      this.$store.commit('IS_PLAY_MODIFY', val);
      this.changeMusic('trueOne', val);
      // this.$store.commit('CURRENT_MUSIC', {
      //   data: this.musicUrl[val],
      //   play: true,
      // })
    },
    musicUrl1(val) {
      this.musicUrl = val;
    },
  },
  deactivated() { // 切换到无Play组件的页面需要将数据重置
    if (this.$route.name !== 'music-boutique' && this.$route.name !== 'music-index') {
      this.getMusicList(1);
    }
  },
  mounted() {
    // 获取music数据
    this.getMusicList(1);
  },
  methods: {
    // 获取music数据
    getMusicList(page) {
      getMusicList(page)
        .then(({ data: res }) => {
          if (page == 1) {
            this.musicUrl = res.articles;
            this.musicUrl.map((item) => {
              if (typeof item.summary === 'string') {
                item.summary = item.summary.split('##');
              }
            });
            this.$store.commit('MUSIC_URL', this.musicUrl);
          }
        })
        .catch((err) => {
          console.log(err, 321);
        });
    },
    // 检测是否被挂起，或处于后台状态
    onBackstage() {
      const string = document.visibilityState;
      if (string === 'hidden') {
        // 当页面由前端运行在后端时，出发此代码
        // console.log('我被隐藏了')
        this.playPause();
      }
    },
    // 同步播放按钮状态
    toPlay(val) {
      if (val) {
        this.playMusic();
      } else {
        this.playPause();
      }
    },
    // 播放
    playMusic() {
      if (
        this.$store.state.music.isShow === -1
        && this.$store.state.music.isPlay === -1
      ) {
        this.$store.commit('IS_SHOW_MODIFY', 0);
        this.$store.commit('IS_PLAY_MODIFY', 0);
        this.$store.commit('CURRENT_MUSIC', { data: this.musicUrl[0], play: true });
      }
      this.$refs.audio.play();
      this.ispause = true;
      this.counting();
      this.getLine();
      document.addEventListener('visibilitychange', this.onBackstage);
    },
    appearPlay() {
      PTTSendClick('btn', 'play-bar-music', '播放按钮');
    },
    appearPause() {
      PTTSendClick('btn', 'pause-bar-music', '停止按钮');
    },
    // 暂停
    playPause() {
      if (!this.$refs.audio.pause) return;
      this.$refs.audio.pause();
      this.ispause = false;
    },
    // 获取总时长
    getAllTime() {
      this.all = this.$refs.audio.duration;
      const minute = parseInt(this.all / 60, 10);
      const second = parseInt(this.all - 60 * minute, 10);
      if (second >= 0 && second < 10) {
        this.allTimes = `0${minute}:` + `0${second}`;
      } else {
        this.allTimes = `0${minute}:${second}`;
      }
    },
    // 获取当前播放时长
    getNowTime() {
      this.now = this.$refs.audio.currentTime;
      this.getTime(this.now);
      if (this.now >= this.all - 1) {
        // 片尾跳转下一曲
        this.$store.commit('MUSIC_INDEX', this.$store.state.music.musicIndex + 1);// 音乐索引加一
        if (this.$store.state.music.musicIndex >= this.musicUrl.length) {
          // 如果音乐索引超过长度，将音乐索引清零
          this.$store.commit('MUSIC_INDEX', 0);
        }
        this.playPause(); // 重载音乐后进行播放
        setTimeout(() => {
          this.playMusic();
        }, 500);
      }
      if (this.now == this.all) {
        this.playPause();
      }
    },
    // 刷新当前播放时间
    counting() {
      const timer = setInterval(() => {
        if (
          this.$route.name !== 'music-boutique'
          && this.$route.name !== 'music-index'
        ) {
          this.state = false;
          clearInterval(timer);
          return;
        }
        this.getNowTime();
        if (this.state) {
          clearInterval(timer);
        }
      }, 100);
    },
    // 刷新当前进度条
    getLine() {
      const timer2 = setInterval(() => {
        if (
          this.$route.name !== 'music-boutique'
          && this.$route.name !== 'music-index'
        ) {
          this.state = false;
          this.$store.commit('IS_PAUSE_MODIFY', false);
          this.$store.commit('IS_SHOW_MODIFY', -1);
          this.$store.commit('IS_PLAY_MODIFY', -1);
          this.$store.commit('MUSIC_INDEX', 0);
          clearInterval(timer2);
          return;
        }
        this.currentP = (this.now / this.all) * 100;
        if (this.state) {
          clearInterval(timer2);
        }
      }, 100);
    },
    // 拖拽移动进度
    touchstart() {
      this.state = true;
      this.initialW = this.$refs.bar.clientWidth;
    },
    touchmove(event) {
      let long = event.touches[0].clientX - this.initialW; // 拖动长度
      if (long > this.$refs.maxBar.clientWidth - this.initialW) {
        long = this.$refs.maxBar.clientWidth - this.initialW;
      }
      if (long < -this.initialW) {
        long = -this.initialW;
      }
      this.currentPSave =        ((this.initialW + long) / this.$refs.maxBar.clientWidth) * 100;
      this.currentP = this.currentPSave;
      this.getTime((this.currentPSave / 100) * this.all);
    },
    touchend() {
      this.$refs.audio.currentTime = (this.currentPSave / 100) * this.all;
      this.state = false;
      this.counting();
      this.getLine();
    },
    // 切换歌曲
    changeMusic(direction, index) {
      if (direction == 'trueOne') {
        this.$store.commit('MUSIC_INDEX', index);
      } else {
        if (direction == 'before') {
          this.$store.commit('MUSIC_INDEX', this.$store.state.music.musicIndex - 1);
          PTTSendClick('btn', 'previous-music', '切换上一曲');
        } else {
          this.$store.commit('MUSIC_INDEX', this.$store.state.music.musicIndex + 1);
          PTTSendClick('btn', 'next-music', '切换下一曲');
        }
      }
      if (this.$store.state.music.musicIndex < 0) {
        this.$store.commit('MUSIC_INDEX', this.musicUrl.length - 1);
      }
      if (this.$store.state.music.musicIndex == this.musicUrl.length) {
        this.$store.commit('MUSIC_INDEX', 0);
      }
      // this.playPause()
      setTimeout(() => {
        this.playMusic();
      }, 500);
    },
    // 计算时间
    getTime(nowTime) {
      const minute = parseInt(nowTime / 60, 10);
      const second = parseInt(nowTime - 60 * minute, 10);
      if (second >= 0 && second < 10) {
        this.currentTime = `0${minute}:` + `0${second}`;
      } else {
        this.currentTime = `0${minute}:${second}`;
      }
    },
  },
};
</script>

<style lang="scss" src="./index.scss" scoped></style>
